import { Dealer } from '../modules/entities/Entities';

export function buildDealerAddress(dealer: Dealer) {
  return [dealer.address, dealer.city, dealer.postalCode, dealer.country].filter((x) => !!x).join(', ');
}
